//imports
import {
    NOTES_CREATE_EDIT_OPEN_MODAL,
    NOTES_GET_NOTE_REQUEST,
    NOTES_GET_NOTE_RESULT,
    NOTES_CREATE_REQUEST,
    NOTES_CREATE_RESULT,
    NOTES_UPDATE_REQUEST,
    NOTES_UPDATE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    create: null,
    update: null,
    currentId: null,
    noteEdit: null
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case NOTES_CREATE_EDIT_OPEN_MODAL:
            return { ...state, openModal: true, currentId: action.payload }

        case NOTES_CREATE_REQUEST:
            return { ...state, loading: true }

        case NOTES_CREATE_RESULT:
            return { ...state, loading: false, create: action.payload }

        case NOTES_UPDATE_REQUEST:
            return { ...state, loading: true }

        case NOTES_UPDATE_RESULT:
            return { ...state, loading: false, update: action.payload }

        case NOTES_GET_NOTE_REQUEST:
            return { ...state, loading: true }

        case NOTES_GET_NOTE_RESULT:
            return { ...state, loading: false, noteEdit: action.payload }

        case CLEAR_REDUX:
            return ["", "NOTES_CREATE_EDIT"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};